import { render, staticRenderFns } from "./ClientView.vue?vue&type=template&id=cd01959c&"
import script from "./ClientView.vue?vue&type=script&lang=js&"
export * from "./ClientView.vue?vue&type=script&lang=js&"
import style0 from "./ClientView.vue?vue&type=style&index=0&id=cd01959c&prod&lang=css&"
import style1 from "./ClientView.vue?vue&type=style&index=1&id=cd01959c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports